// Texty stránky „Servis nářadí" (servicePage.js).
export default {
  order: 'Objednat servis',
  pricelist: 'Zobrazit ceník',
  warranty: 'Záruka na opravy',
  warrantySub: '10+ let praxe týmu',
  servicesHint: 'Od diagnostiky po náhradní díly',
  noFees: 'Bez skrytých poplatků',
  bandMail: 'Napsat servisu',
  services: 'Co nabízíme v rámci servisu',
  pricing: 'Orientační ceník servisu',
  why: 'Proč si vybrat náš servis?',
  /** chip ceny z administrace, který znamená zdarma (zelený) */
  freeRe: /zdarma/i,
};
